import {observable, computed, action, makeAutoObservable} from 'mobx'
import tabs from '../constants/newsConst'
import * as Api from '@/utils/api/api'

// interface NewsBanner {
//   pic: String;
//   src?: String;
// }
//
// interface NewsItem {
//   pic: String;
//   src: String;
//   title: String;
//   author: String;
//   view: Number;
// }

class NewsStore {
  bannerList = []
  list = []
  PAGE_SIZE = 8
  pageSize = this.PAGE_SIZE
  pageNum = 1
  title = ''
  categoryId = undefined
  categoryList = []
  refreshing = false

  constructor() {
    makeAutoObservable(this)
  }

  /**
   * 初始化
   */
   init() {
    this.bannerList = []
    this.list = []
    this.pageSize = this.PAGE_SIZE
    this.pageNum = 1
    this.title = ''
    this.categoryId = undefined
  }

  /**
   * 获取资讯信息列表
   */
   async fetchList() {
    try {
      const { pageNum, pageSize, categoryId, title } = this
      const { list } = await Api.newsList({
        pageNum,
        pageSize,
        categoryId,
        title
      })

      this.list = list
      this.refreshing = false
    } catch (error) {}
  }

  /**
   * 获取类别列表
   */
   async fetchCategoryList() {
    try {
      let { list, totalNum } = await Api.newsCategoryList()

      this.categoryList = [
        {
          id: undefined,
          name: '全部资讯',
          isUrl: false
        },
        ...list
      ]
    } catch (error) {}
  }
}

const store = new NewsStore()

export default store
